import { FC } from "react";
// Redux
import { useAppSelector } from "hooks/useStore";
import { selectQuestionIndex, selectQuestionsLength, selectQuiz } from "store/quiz/quizSelectors";
import { selectResult, selectTotalScore } from "store/player/playerSelectors";
import IQuiz from "models/Quiz";
// Icons
import { IoIosArrowBack } from "react-icons/io";
// i18next
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

type Props = {
  scoreVisible?: boolean;
  questionNumberVisible?: boolean;
  handleBack?: () => void;
}

const AppBar:FC<Props> = ({ scoreVisible = false, questionNumberVisible = false, handleBack }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const quiz:IQuiz | null = useAppSelector(selectQuiz);
  const result = useAppSelector(selectResult);
  const questionIndex = useAppSelector(selectQuestionIndex);
  const questionsLength = useAppSelector(selectQuestionsLength);
  const totalScore:number = useAppSelector(selectTotalScore);

  const endpoint = pathname.split('/').pop();

  const showSponsorLogo = quiz && quiz.sponsorImage && endpoint && quiz.sponsorImagePages?.includes(endpoint);

  const logoUrl = showSponsorLogo ? quiz.sponsorImage : quiz?.logoImage;
  const bgColor = showSponsorLogo ? quiz.sponsorImageBackgroundColor : quiz?.logoImageBackgroundColor;

  const logoImage = result && result.quizGroup
    ? result.quizGroup.logoImage
    : logoUrl;
  const logoBgColor = result && result.quizGroup
    ? result.quizGroup.logoImageBackgroundColor
    : bgColor;

  if (!quiz) return null;
  return (
    <div className="w-full flex justify-between items-center">
      <div className="w-24">
        {handleBack !== undefined && quiz.callToAction?.enabled ? (
          <button onClick={handleBack} className="p-1 flex items-center gap-2 text-primary transition-colors hover:bg-[rgba(255,255,255,0.12)]">
            <IoIosArrowBack />
            <p>{t('buttons.back')}</p>
          </button>
        ) : null}
        {questionNumberVisible ? (
          <p className="text-lg text-right text-primary font-bold">{`Q${questionIndex} of ${questionsLength}`}</p>
        ) : null}
      </div>
      <div>
        <img src={logoImage} alt="logo" className="h-12 shadow-primary" style={{ backgroundColor: logoBgColor }} />
      </div>
      <div className="w-24 flex justify-end">
        {scoreVisible ? (
          <div className="text-right text-primary font-bold">
            <p className="text-sm">{t('labels.totalScore')}</p>
            <p className="text-3xl">{totalScore}</p>
          </div>
        ) : null}
      </div>
    </div>
  );
}
 
export default AppBar;
